import organizationsService from '../../../services/Organizations'
import promotionsService from '../../../services/Promotions'
import { subscriptionService } from '../../../services/Subscriptions'
import {
  IBankAccountObj,
  ICreateBankAccountObj,
  ILegalEntityObj,
  IMap,
  IOrgCreateObj,
  IOrgObj,
  IServiceObject,
  IStateUserRole,
  ActionsUnion,
  IPromotion,
  ICreatePromotion,
  IOrgSubscriptionResponseDTO,
  ICreateOrgSubscriptionDTO,
  IUpdateOrgSubscriptionDTO,
  IPromotionFilter,
  IRiderSearchObject,
  IGetRidersPerPromotion,
  IRiderReponseObject
} from '../../../types/'
import { actionCreators as mapsActionCreators } from '../google_map'
import * as constants from '../../constants/'
import { createAction } from '../helpers'
import { setTimeoutToRefreshToken } from '../../../utils/auth'
import { dispatch } from 'react-hot-toast/dist/core/store'
import { string } from 'prop-types'

export const actionCreators = {
  updatePromotionFilters: (filters: IPromotionFilter) => createAction(constants.UPDATE_PROMOTIONS_FILTERS, filters),

  setCurrentOrganizationRequest: (data: string) => createAction(constants.CURRENT_ORG_ID_REQUEST, data),
  setCurrentOrganizationSuccess: (data: IOrgObj) => createAction(constants.SET_CURRENT_ORG_SUCCESS, data),
  setCurrentOrganizationFail: (error: string) => createAction(constants.GET_VEHICLES_FAIL, error),

  fetchOrganizationsRequest: () => createAction(constants.FETCH_ALL_ORGANIZATIONS),
  fetchOrganizationsSuccess: (data: IOrgObj[]) => createAction(constants.FETCH_ALL_ORGANIZATIONS_SUCCESS, data),
  fetchOrganizationsFail: (error: string) => createAction(constants.FETCH_ALL_ORGANIZATIONS_FAIL, error),

  createOrgRequest: () => createAction(constants.CREATE_ORGANIZATION),
  createOrgSuccess: (data: IMap<IOrgObj>) => createAction(constants.CREATE_ORGANIZATION_SUCCESS, data),
  createOrgFail: (error: string) => createAction(constants.CREATE_ORGANIZATION_FAIL, error),

  createOrganizationBankAccountRequest: () => createAction(constants.CREATE_ORGANIZATION_BANK_ACCOUNT_REQUEST),
  createOrganizationBankAccountSuccess: (data: IMap<IBankAccountObj>) =>
    createAction(constants.CREATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS, data),
  createOrganizationBankAccountFailure: (error: string) =>
    createAction(constants.CREATE_ORGANIZATION_BANK_ACCOUNT_FAILURE, error),

  createOrganizationLegalEntityRequest: () => createAction(constants.CREATE_ORGANIZATION_LEGAL_ENTITY_REQUEST),
  createOrganizationLegalEntitySuccess: (data: ILegalEntityObj) =>
    createAction(constants.CREATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS, data),
  createOrganizationLegalEntityFailure: (error: string) =>
    createAction(constants.CREATE_ORGANIZATION_LEGAL_ENTITY_FAILURE, error),

  getOrganizationLegalEntityRequest: () => createAction(constants.GET_ORGANIZATION_LEGAL_ENTITY_REQUEST),
  getOrganizationLegalEntitySuccess: (data: any) => createAction(constants.GET_ORGANIZATION_LEGAL_ENTITY_SUCCESS, data),
  getOrganizationLegalEntityFailure: (error: string) =>
    createAction(constants.GET_ORGANIZATION_LEGAL_ENTITY_FAILURE, error),

  removeOrganizationBankAccountRequest: () => createAction(constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_REQUEST),
  removeOrganizationBankAccountSuccess: (data: any) =>
    createAction(constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_SUCCESS, data),
  removeOrganizationBankAccountFailure: (error: string) =>
    createAction(constants.REMOVE_ORGANIZATION_BANK_ACCOUNT_FAILURE, error),

  updateOrganizationBankAccountRequest: () => createAction(constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_REQUEST),
  updateOrganizationBankAccountSuccess: (data: any) =>
    createAction(constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_SUCCESS, data),
  updateOrganizationBankAccountFailure: (error: string) =>
    createAction(constants.UPDATE_ORGANIZATION_BANK_ACCOUNT_FAILURE, error),

  setUpdateOrganization: () => createAction(constants.ORG_UPDATE_REQUEST),
  setUpdateOrganizationSuccess: (data: IOrgObj) => createAction(constants.ORG_UPDATE_SUCCESS, data),
  setUpdateOrganizationFail: (error: string) => createAction(constants.ORG_UPDATE_FAIL, error),

  updateOrganizationLegalEntityRequest: () => createAction(constants.UPDATE_ORGANIZATION_LEGAL_ENTITY_REQUEST),
  updateOrganizationLegalEntitySuccess: (data: any) =>
    createAction(constants.UPDATE_ORGANIZATION_LEGAL_ENTITY_SUCCESS, data),
  updateOrganizationLegalEntityFailure: (error: string) =>
    createAction(constants.UPDATE_ORGANIZATION_LEGAL_ENTITY_FAILURE, error),

  fetchSingleOrganizationRequest: () => createAction(constants.FETCH_SINGLE_ORGANIZATION),
  fetchSingleOrganizationSuccess: (data: IOrgObj) => createAction(constants.FETCH_SINGLE_ORGANIZATION_SUCCESS, data),
  fetchSingleOrganizationFail: (error: string) => createAction(constants.FETCH_SINGLE_ORGANIZATION_FAIL, error),

  searchRequest: () => createAction(constants.ORG_SEARCH_REQUEST),
  searchSuccess: (data: { [key: string]: IOrgObj }) => createAction(constants.ORG_SEARCH_SUCCESS, data),
  searchFail: (error: string) => createAction(constants.ORG_SEARCH_FAIL, error),

  orgsForDriverRequest: () => createAction(constants.ORG_LIST_BY_DRIVER_REQUEST),
  orgsForDriverSuccess: (data: any) => createAction(constants.ORG_LIST_BY_DRIVER_SUCCESS, data),
  orgsForDriverFail: (error: string) => createAction(constants.ORG_LIST_BY_DRIVER_FAIL, error),

  createOrgClear: () => createAction(constants.CREATE_ORGANIZATION_CLEAR),
  clearOrganizationLegalEntity: () => createAction(constants.CLEAR_ORGANIZATION_LEGAL_ENTITY),

  organizationListRequest: () => createAction(constants.ORGANIZATION_LIST_REQUEST),
  organizationListSuccess: (data: { [key: string]: IOrgObj }) =>
    createAction(constants.ORGANIZATION_LIST_SUCCESS, data),
  organizationListFail: (error: string) => createAction(constants.ORGANIZATION_LIST_FAILURE, error),

  fetchOrganizationPromotions: () => createAction(constants.FETCH_ORGANIZATION_PROMOTIONS),
  fetchOrganizationPromotionsSuccess: (data: { orgId: string; promotions: IPromotion[] }) =>
    createAction(constants.FETCH_ORGANIZATION_PROMOTIONS_SUCCESS, data),
  fetchOrganizationPromotionsFail: (error: string) => createAction(constants.FETCH_ORGANIZATION_PROMOTIONS_FAIL, error),

  fetchPromotionsList: () => createAction(constants.FETCH_ORGANIZATION_PROMOTIONS),
  fetchPromotionsListSuccess: (data: { promotions: IPromotion[] }) =>
    createAction(constants.FETCH_ORGANIZATION_PROMOTIONS_SUCCESS, data),
  fetchPromotionsListFail: (error: string) => createAction(constants.FETCH_ORGANIZATION_PROMOTIONS_FAIL, error),

  getRidersPerPromotionRequest: () => createAction(constants.GET_RIDERS_PER_PROMOTION_REQUEST),
  getRidersPerPromotionSuccess: (riders: IRiderReponseObject[]) =>
    createAction(constants.GET_RIDERS_PER_PROMOTION_SUCCESS, riders),
  getRidersPerPromotionCount: (count: number) => createAction(constants.GET_RIDERS_PER_PROMOTION_COUNT, count),
  getRidersPerPromotionFailure: (error: string) => createAction(constants.GET_RIDERS_PER_PROMOTION_FAILURE, error),

  fetchPromotionsListCountSuccess: (count: number) =>
    createAction(constants.FETCH_ORGANIZATION_PROMOTIONS_COUNT_SUCCESS, count),

  createPromotion: () => createAction(constants.CREATE_PROMOTION),
  createPromotionSuccess: (data: IPromotion) => createAction(constants.CREATE_PROMOTION_SUCCESS, data),
  createPromotionFail: (error: string) => createAction(constants.CREATE_PROMOTION_FAIL, error),

  deletePromotion: () => createAction(constants.DELETE_PROMOTION),
  deletePromotionSuccess: (data: IPromotion) => createAction(constants.DELETE_PROMOTION_SUCCESS, data),
  deletePromotionFail: (error: string) => createAction(constants.DELETE_PROMOTION_FAIL, error),

  switchOrganization: (id: string) => createAction(constants.SWITCH_ORGANIZATION, id),

  getOrgSubscriptionRequest: () => createAction(constants.ORGANIZATION_GET_SUBSCRIPTION),
  getOrgSubscriptionSuccess: (subscription: IOrgSubscriptionResponseDTO) =>
    createAction(constants.ORGANIZATION_GET_SUBSCRIPTION_SUCCESS, subscription),
  getOrgSubscriptionFail: () => createAction(constants.ORGANIZATION_GET_SUBSCRIPTION_FAILURE),

  createOrgSubscriptionRequest: () => createAction(constants.ORGANIZATION_CREATE_SUBSCRIPTION),
  createOrgSubscriptionSuccess: (subscription: IOrgSubscriptionResponseDTO) =>
    createAction(constants.ORGANIZATION_CREATE_SUBSCRIPTION_SUCCESS, subscription),
  createOrgSubscriptionFail: (error: string) => createAction(constants.ORGANIZATION_CREATE_SUBSCRIPTION_FAIL, error),

  updateOrgSubscriptionRequest: () => createAction(constants.ORGANIZATION_UPDATE_SUBSCRIPTION),
  updateOrgSubscriptionSuccess: (subscription: IOrgSubscriptionResponseDTO) =>
    createAction(constants.ORGANIZATION_UPDATE_SUBSCRIPTION_SUCCESS, subscription),
  updateOrgSubscriptionFail: (error: string) => createAction(constants.ORGANIZATION_UPDATE_SUBSCRIPTION_FAIL, error),

  resetOrgMetadata: () => createAction(constants.RESET_ORGANIZATION_METADATA)
}

export function setCurrentOrganization(organizationId: string) {
  const { setCurrentOrganizationRequest, setCurrentOrganizationSuccess, setCurrentOrganizationFail } = actionCreators
  return (dispatch: any) => {
    dispatch(setCurrentOrganizationRequest(organizationId))
    organizationsService.getSingleOrg(organizationId).then(
      (data: IOrgObj) => {
        dispatch(setCurrentOrganizationSuccess(data))
        dispatch(getOrgSubscription(data.id))
        if (data.serviceAreaBounds && data.serviceAreaBounds.length === 4) {
          const bounds = new window.google.maps.LatLngBounds()
          const p1 = { lat: parseFloat(data.serviceAreaBounds[0]), lng: parseFloat(data.serviceAreaBounds[2]) }
          const p2 = { lat: parseFloat(data.serviceAreaBounds[1]), lng: parseFloat(data.serviceAreaBounds[3]) }
          bounds.extend(p1)
          bounds.extend(p2)
          dispatch(mapsActionCreators.setBounds(bounds))
        }
        return data
      },
      (error: string) => dispatch(setCurrentOrganizationFail(error))
    )
  }
}

export function getAllOrganizations() {
  const { fetchOrganizationsRequest, fetchOrganizationsSuccess, fetchOrganizationsFail } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchOrganizationsRequest())
    return organizationsService.getAllOrganizations().then(
      (data: IOrgObj[]) => {
        dispatch(fetchOrganizationsSuccess(data))
        return data
      },
      (error: any) => dispatch(fetchOrganizationsFail(error.data))
    )
  }
}

export const createOrg = (data: IOrgCreateObj, setCurrent?: boolean) => (dispatch: any) => {
  const { createOrgRequest, createOrgSuccess, createOrgFail } = actionCreators
  dispatch(createOrgRequest())
  return organizationsService.createOrg(data).then(
    (response: IMap<IOrgObj>) => {
      dispatch(createOrgSuccess(response))
      if (setCurrent) {
        const orgId = Object.keys(response)[0]
        dispatch(setCurrentOrganization(orgId))
        setTimeoutToRefreshToken(0)
      }
    },
    (error: string) => dispatch(createOrgFail(error))
  )
}

export const createOrganizationBankAccount = (data: ICreateBankAccountObj, orgId: string) => (dispatch: any) => {
  const {
    createOrganizationBankAccountRequest,
    createOrganizationBankAccountSuccess,
    createOrganizationBankAccountFailure
  } = actionCreators
  dispatch(createOrganizationBankAccountRequest())
  return organizationsService
    .createOrganizationBankAccount(data, orgId)
    .then(
      (response: IMap<IBankAccountObj>) =>
        dispatch(createOrganizationBankAccountSuccess({ orgId, accounts: response } as any)),
      (error: string) => dispatch(createOrganizationBankAccountFailure(error))
    )
}

export const createOrgClear = () => (dispatch: any) => {
  const { createOrgClear } = actionCreators
  dispatch(createOrgClear())
}

export const clearOrganizationLegalEntity = () => (dispatch: any) => {
  const { clearOrganizationLegalEntity } = actionCreators
  dispatch(clearOrganizationLegalEntity())
}

export const switchOrganization = (id: string) => (dispatch: any) => {
  const { switchOrganization } = actionCreators
  dispatch(switchOrganization(id))
}

export const createOrganizationLegalEntity = (data: ILegalEntityObj, orgId: string) => (dispatch: any) => {
  const {
    createOrganizationLegalEntityRequest,
    createOrganizationLegalEntitySuccess,
    createOrganizationLegalEntityFailure
  } = actionCreators
  dispatch(createOrganizationLegalEntityRequest())
  return organizationsService
    .createOrganizationLegalEntity(data, orgId)
    .then(
      (response: any) =>
        dispatch(
          createOrganizationLegalEntitySuccess({ ...data, orgId, connectURL: response.url ? response.url : '' } as any)
        ),
      (error: string) => dispatch(createOrganizationLegalEntityFailure(error))
    )
}

export const getOrganizationLegalEntity = (orgId: string) => (dispatch: any) => {
  const {
    getOrganizationLegalEntityRequest,
    getOrganizationLegalEntitySuccess,
    getOrganizationLegalEntityFailure
  } = actionCreators
  dispatch(getOrganizationLegalEntityRequest())
  return organizationsService
    .getOrganizationLegalEntity(orgId)
    .then(
      (data: any) => dispatch(getOrganizationLegalEntitySuccess(data)),
      (error: string) => dispatch(getOrganizationLegalEntityFailure(error))
    )
}

export const removeOrganizationBankAccount = (orgId: string, bankAccountId: string) => (dispatch: any) => {
  const {
    removeOrganizationBankAccountRequest,
    removeOrganizationBankAccountSuccess,
    removeOrganizationBankAccountFailure
  } = actionCreators
  dispatch(removeOrganizationBankAccountRequest())
  return organizationsService
    .removeOrganizationBankAccount(orgId, bankAccountId)
    .then(
      (response: string) => dispatch(removeOrganizationBankAccountSuccess({ orgId, bankAccountId } as any)),
      (error: string) => dispatch(removeOrganizationBankAccountFailure(error))
    )
}

export const setOrganizationDefaultBankAccount = (orgId: string, bankAccountId: string) => (dispatch: any) => {
  const {
    updateOrganizationBankAccountRequest,
    updateOrganizationBankAccountSuccess,
    updateOrganizationBankAccountFailure
  } = actionCreators
  dispatch(updateOrganizationBankAccountRequest())
  return organizationsService
    .setOrganizationDefaultBankAccount(orgId, bankAccountId)
    .then(
      (response: IMap<IBankAccountObj>) => dispatch(updateOrganizationBankAccountSuccess({ response, orgId })),
      (error: string) => dispatch(updateOrganizationBankAccountFailure(error))
    )
}

export function updateOrganization(data: IOrgObj) {
  const { setUpdateOrganization, setUpdateOrganizationSuccess, setUpdateOrganizationFail } = actionCreators
  return (dispatch: any) => {
    dispatch(setUpdateOrganization())
    return organizationsService
      .updateOrg(data)
      .then(
        organization => dispatch(setUpdateOrganizationSuccess(organization)),
        (error: string) => dispatch(setUpdateOrganizationFail(error))
      )
  }
}

export const updateOrganizationLegalEntity = (organizationLegalEntity: ILegalEntityObj, orgId: string) => (
  dispatch: any
) => {
  const {
    updateOrganizationLegalEntityRequest,
    updateOrganizationLegalEntitySuccess,
    updateOrganizationLegalEntityFailure
  } = actionCreators
  dispatch(updateOrganizationLegalEntityRequest())
  return organizationsService
    .updateOrgLegalEntity(organizationLegalEntity, orgId)
    .then(
      () => dispatch(updateOrganizationLegalEntitySuccess({ ...organizationLegalEntity, orgId })),
      (error: string) => dispatch(updateOrganizationLegalEntityFailure(error))
    )
}

export function getSingleOrganization(id: string) {
  const { fetchSingleOrganizationRequest, fetchSingleOrganizationSuccess, fetchSingleOrganizationFail } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchSingleOrganizationRequest())
    organizationsService.getSingleOrg(id).then(
      (data: IOrgObj | any) => {
        dispatch(fetchSingleOrganizationSuccess(data))
        dispatch(getOrgSubscription(data.id))
      },
      (error: string) => dispatch(fetchSingleOrganizationFail(error))
    )
  }
}

export function search(query: string) {
  const { searchRequest, searchSuccess, searchFail } = actionCreators
  return (dispatch: any) => {
    dispatch(searchRequest())
    organizationsService
      .search(query)
      .then(
        (items: { [key: string]: IOrgObj }) => dispatch(searchSuccess(items)),
        (error: string) => dispatch(searchFail(error))
      )
  }
}

export function getOrganizationsForDriver(driverId: string) {
  const { orgsForDriverRequest, orgsForDriverSuccess, orgsForDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(orgsForDriverRequest())
    organizationsService.getOrganizationsByDriverId(driverId).then(
      ({ organizations, services }) => {
        dispatch(orgsForDriverSuccess({ organizations, services }))
      },
      (error: string) => dispatch(orgsForDriverFail(error))
    )
  }
}

export function getOrganizationPromotions(orgId: string) {
  const {
    fetchOrganizationPromotions,
    fetchOrganizationPromotionsFail,
    fetchOrganizationPromotionsSuccess
  } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchOrganizationPromotions())
    promotionsService.getPromotions(orgId).then(
      promotions => {
        dispatch(
          fetchOrganizationPromotionsSuccess({
            orgId,
            promotions: promotions.items
          })
        )
      },
      (error: string) => dispatch(fetchOrganizationPromotionsFail(error))
    )
  }
}

export function getPromotionsList(params: IPromotionFilter) {
  const {
    fetchPromotionsList,
    fetchPromotionsListFail,
    fetchPromotionsListSuccess,
    fetchPromotionsListCountSuccess
  } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchPromotionsList())
    return promotionsService.fetch(params).then(
      promotions => {
        dispatch(fetchPromotionsListSuccess({ promotions: promotions.items }))
        dispatch(fetchPromotionsListCountSuccess(promotions.count))
        return promotions
      },
      (error: string) => dispatch(fetchPromotionsListFail(error))
    )
  }
}
export function createPromotion(promotion: ICreatePromotion) {
  const { createPromotion, createPromotionSuccess, createPromotionFail } = actionCreators
  return async (dispatch: any) => {
    dispatch(createPromotion())
    return promotionsService.createPromotion(promotion).then(
      createdPromotion => {
        dispatch(createPromotionSuccess(createdPromotion))
        return createdPromotion
      },
      (error: string) => dispatch(createPromotionFail(error))
    )
  }
}

export function deletePromotion(promotionId: string) {
  const { deletePromotion, deletePromotionSuccess, deletePromotionFail } = actionCreators
  return (dispatch: any) => {
    dispatch(deletePromotion())
    return promotionsService.deletePromotion(promotionId).then(
      createdPromotion => {
        dispatch(deletePromotionSuccess(createdPromotion))
        dispatch(
          getPromotionsList({
            orgId: createdPromotion.orgId,
            skip: 0,
            sortBy: [],
            take: 10
          })
        )
        return createdPromotion
      },
      (error: string) => dispatch(deletePromotionFail(error))
    )
  }
}

export const getRidersPerPromotion = (params: IGetRidersPerPromotion) => (dispatch: any) => {
  const {
    getRidersPerPromotionRequest,
    getRidersPerPromotionFailure,
    getRidersPerPromotionSuccess,
    getRidersPerPromotionCount
  } = actionCreators
  dispatch(getRidersPerPromotionRequest())
  return promotionsService
    .getRidersPerPromotion(params)
    .then((data: { items: IRiderReponseObject[]; count: number }) => {
      dispatch(getRidersPerPromotionSuccess(data.items))
      dispatch(getRidersPerPromotionCount(data.count))
    })
    .catch(err => {
      dispatch(getRidersPerPromotionFailure(err))
    })
}

export const archivePromotion = (promotionId: string) => (dispatch: any) => {
  const { deletePromotionFail } = actionCreators
  return promotionsService
    .removePromotionsFromRiders(promotionId)
    .then(createdPromotion => {
      dispatch(
        getPromotionsList({
          orgId: createdPromotion.orgId,
          skip: 0,
          sortBy: [],
          take: 10
        })
      )
    })
    .catch((err: string) => dispatch(deletePromotionFail(err)))
}

export const getOrgSubscription = (id: string) => (dispatch: any) => {
  const { getOrgSubscriptionRequest, getOrgSubscriptionSuccess, getOrgSubscriptionFail } = actionCreators
  dispatch(getOrgSubscriptionRequest())
  subscriptionService
    .getOrgSubscription(id)
    .then((subscription: IOrgSubscriptionResponseDTO) => {
      dispatch(getOrgSubscriptionSuccess(subscription))
    })
    .catch(error => {
      dispatch(getOrgSubscriptionFail())
    })
}

export const createOrgSubscription = (dto: ICreateOrgSubscriptionDTO) => (dispatch: any) => {
  const { createOrgSubscriptionRequest, createOrgSubscriptionSuccess, createOrgSubscriptionFail } = actionCreators
  dispatch(createOrgSubscriptionRequest())
  subscriptionService
    .createOrgSubscription(dto)
    .then((subscription: IOrgSubscriptionResponseDTO) => {
      dispatch(createOrgSubscriptionSuccess(subscription))
    })
    .catch(error => {
      dispatch(createOrgSubscriptionFail(error))
    })
}

export const updateOrgSubscription = (dto: IUpdateOrgSubscriptionDTO) => (dispatch: any) => {
  const { updateOrgSubscriptionRequest, updateOrgSubscriptionSuccess, updateOrgSubscriptionFail } = actionCreators
  dispatch(updateOrgSubscriptionRequest())
  subscriptionService
    .updateOrgSubscription(dto)
    .then((subscription: IOrgSubscriptionResponseDTO) => {
      dispatch(updateOrgSubscriptionSuccess(subscription))
    })
    .catch(error => {
      dispatch(updateOrgSubscriptionFail(error))
    })
}

export type IOrganizationActions = ActionsUnion<typeof actionCreators>



// WEBPACK FOOTER //
// ./src/state/actions/organizations/index.ts